import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { ADMIN_URL } from './constant/BaseApiUrl';

export default class UserAuthorizationsService {
  getListRolePerMission() {
    return axios.get(`${ADMIN_URL}${ApiKey.LIST_ROLE_PERMISSION}`);
  }
  getPermissionByRole(role) {
    return axios.get(`${ADMIN_URL}${ApiKey.LIST_ROLE_PERMISSION}/${role}`);
  }
  updatePermissionRole(body) {
    return axios.post(`${ADMIN_URL}${ApiKey.LIST_ROLE_PERMISSION}`, body);
  }
}
